(async () => {
  const { hideElement } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('announcement-bar', class extends baseComponent.default {
    elements = {
      buttonClose: '[data-dismiss]',
    }

    render() {
      if (this.hasAttribute('dismissible')) {
        this._useDismiss();
      }
    };

    // The bar ships visible and is hidden before paint by an inline script in
    // sections/announcement-bar.liquid, so this no longer reveals anything - it
    // only wires up the dismiss button. Revealing from here cost a 0.078979
    // layout shift because this module resolves long after first paint.
    _useDismiss() {
      this.$buttonClose.addEventListener('click', this._closeBar.bind(this), { once: true });
    };

    _closeBar() {
      window.sessionStorage.setItem('hideAnnouncement', 'true');
      hideElement(this)
    }
  });
})();